import { createSocket } from '@leprecoins/effector-sockets';
import { SOCKET_URL } from 'shared/config';
import { authModel } from './auth-model';

export const [socket, createSend, createReceive] = createSocket({
	url: SOCKET_URL,
	transports: ['websocket'],
	errors: ['error'],
	auth: authModel.$token.map((token) => ({ token: `Bearer ${token}` })),
});
